import MediaImage from './MediaImage';

export default MediaImage;
